<template>
	<b-container fluid class="dashboard">
		<b-row class="dashContent judgeView">
			<b-col md="12" v-if="resource">    
				<b-form-group label="Status" label-cols-md="2">
					<b-form-select v-model="filter.mregType" @change="doFilter">
						<b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
						<b-form-select-option value="MB">Ballot</b-form-select-option>
						<b-form-select-option value="FR">Fast Runner</b-form-select-option>
					</b-form-select>
				</b-form-group>				
				<!-- <b-form-group label="E-mail Address" label-cols-md="2">
					<b-form-input v-model="search.mbsdEmail" placeholder="Email address to find" @input="doFilter"></b-form-input>
				</b-form-group>				 -->
				<!-- <b-form-group label="Full Name" label-cols-md="2">
					<b-form-input v-model="search.zmemFullName"  placeholder="Full name to find" @input="doFilter"></b-form-input>
				</b-form-group> -->
				<b-pagination-nav
					v-model="currentPage"
					:number-of-pages="maxPage"
					:base-url="'/list/'"
					last-number
					:use-router=useRouter
					align="fill"
					limit=10
					:link-gen="linkGen"
				></b-pagination-nav>
				<b-table striped hover :items="resource.data" :fields="fields">
					<template v-slot:cell(zmemFullName)="row">
						<b-button size="md" @click="show(row)" class="adminListName">
							{{ row.detailsShowing ? '👁' : '👤'}} {{row.item.zmemFullName}}
						</b-button>
					</template>
					<template v-slot:cell(mbsdEmail)="row">
						<b-button size="md" @click="mailTo(row)" class="adminListName">
							{{row.item.mbsdEmail}}
						</b-button>
					</template>

					<template v-slot:row-details="row">
						<div v-if="row.item.detail">
							<b-button block variant="primary" class="mb-3" v-if="row.item.mbsdStatus==0" @click="verifyData(row)">Approve Data</b-button>
							<b-button block variant="primary" class="mb-3" v-if="row.item.mbsdStatus==0" @click="updateProfile(row)">Reject Data</b-button>

							<b-card v-for="(l,f) in row.item.detail.linked" v-bind:data="l" v-bind:key="f">
								<b-card-title v-if="f=='mregZmemId'">Transaction Info</b-card-title>
								<b-card-title v-if="f=='mmedZmemId'">Additional Info</b-card-title>
								<b-card-title v-if="f=='mbsdZmemId'">Member Info</b-card-title>
								<b-card-title v-if="f=='mbspZmemId'">Phone Info</b-card-title>
								<b-row class="mb-2" v-for="(value, key) in l[0]" v-bind:data="value" v-bind:key="key">
									<b-col sm="5" class="text-sm-right"><b>{{key}}</b></b-col>
									<b-col>{{value}}</b-col>
								</b-row>
								<b-button block variant="primary" class="mb-3" v-if="row.item.mregType=='FR'&&f=='mregZmemId'&&l[0]&&l[0].mregStatus==0" @click="approveBallot(l[0])">Approve Fast Runner</b-button>
								<b-button block variant="primary" class="mb-3" v-if="row.item.mregType=='FR'&&f=='mregZmemId'&&l[0]&&l[0].mregStatus==0" @click="rejectFastRunner(l[0])">Reject Fast Runner</b-button>

								<!-- <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button> -->
							</b-card>
							
						</div>
					</template>
					<template v-slot:cell(mbsdFile)="data">
						<!-- `data.value` is the value after formatted by the Formatter -->
						<a target="_blank" :href="'https://private.borobudurmarathon.com/view/'+`${data.value}`" style="font-size:8px;letter-spacing:2px;text-transform:uppercase;display:block">{{ data.value }}</a>
						<a target="_blank" :href="'https://private.borobudurmarathon.com/view/'+`${data.value}`"><img :src="'https://private.borobudurmarathon.com/view/'+`${data.value}`" style="max-width:250px"></a>
					</template>
				</b-table>
			</b-col>		
		</b-row>
	</b-container>
</template>
<style lang="stylus">
	.mailEditor {background: white; padding: 10px;}
</style>
<script>
	import GridContainer from './GridContainer.vue'
	export default {
		data() {
			return {
				search : {
					// mbsdEmail : null,
					zmemFullName : null
				},
				filter : {
					// mbsdStatus :false,
				},
				items : undefined,
				signedin : true,
				data: null,
				content: null,
				editorOption: {},

				currentPage: 1,
				useRouter: true,
				itemsPerPage: 10,
				resource: undefined,
				fields : [
					// 'show_details',
					{
						key: "zmemFullName",
						label : "Full Name"
					},
					{
						key: "mregOrderId",
						label: "Order ID"
					},
					{
						key: "mregStatus",
						label: "Reg Status"
					},
					{
						key: "mregType",
						label: "Reg Type"
					},
				]
			}
		},
		watch: {
			page (to, from) {
				// console.log(to, from);
				this.loadItems(to, from)
			}
		},
		computed: {
			page () {
				return Number(this.$route.params.page) || 1
			},
			totalRows(){
				const { lists } = this.$store.state
				return lists[this.resource].status.totalRecords
			},
			// itemsPerPage(){
			// 	return this.$store.state.itemsPerPage
			// },
			maxPage () {
				// return 1;
				// const { itemsPerPage, lists } = this.$store.state
				// console.log('VVVVVVVVVVVVVVVV ',lists[this.resource].status.totalRecords/itemsPerPage);
				return Math.ceil(this.resource.status.totalRecords/this.itemsPerPage) || 1
			},
			hasMore () {
				return this.page < this.maxPage
			}
		},
		components : {
		},
		methods: {
			mailTo(row){
				this.$router.push({
					path : '/maileditor',
					query : {mbsdEmail:row.value}
				});
				console.log(row);
			},
			show(row){
				console.log('Load detail of : ', row.item.links.mregZmemId);
				// row.item.detail = {};
				var params = {
					filter : {
						zmemId : row.item.links.mregZmemId
					}
				};
				if (!row.item._showDetails){				
					this.$store.dispatch('GETMEMBER', {params:params})
						.then(member=>{
							row.item.detail = member.data;
							row.item._showDetails = false;
							row.item._showDetails = true;
							console.log('CCCCCCCCCCCCCC --- ', row.item);
						})
				}
				row.toggleDetails();
			},
			// like(value, input) {
			// 	console.log(value,input);
			// 	return value;
			// 	// this.filter.
			// 	// return '%'+value+'%'
			// },
			verifyData(row){
				this.$store.dispatch('VERIFYDATA', {fileId:row.item.mbsdFile})
					.then(s=>{
						row.item.mbsdStatus = 1;
						// this.enabled = false;
						console.log(s);
					})
					.catch(e=>{
						console.log(e);
					})
				console.log(row);
			},
			loadItems (to = this.page, from = -1) {
				console.log('Start loading items page : ', this.page, this.$route.query);
				const params = {
					// resource: this.resource,
					params: {
						pageNumber: this.page,
					}
				};
				if (this.$route.query){
					params.params.filter = this.$route.query;
				}
				this.$bar.start()
				this.$store.dispatch('GETREGISTRATIONS', params)
					.then(members => {
						this.currentPage = this.page;
						// console.log('VVVVVVVV', JSON.stringify(members.data.fields));
						this.resource = members.data;
						console.log(members);
						if (this.page < 0 || this.page > this.maxPage) {
							this.$router.replace(`/1`)
							return
						}
						this.transition = from === -1
							? null
							: to > from ? 'slide-left' : 'slide-right'
						this.displayedPage = to
						// this.displayedItems = this.$store.getters.activeItems
						this.$bar.finish()
					})
					.catch(err=>{
						this.resource = {
							data : [],
							status : {
								totalRecords : 0
							}
						};
						this.$bar.finish()
					})
			},
			linkGen(pageNum){
				return {
					path : '/list_fastrunner/'+pageNum,
					query : this.$route.query
				}
			},
			doFilter(){
				for (const key in this.filter) {
					let value = this.filter[key];
					if (!value&&this.filter[key]){
						delete this.filter[key];
					}
				}
				for (const key in this.search) {
					let value = this.search[key];
					if (value){
						this.filter[key] = {
							like : '%'+value+'%'
						}
					} else {
						if (this.filter[key]) delete this.filter[key];
					}
				}
				this.$router.push({query : this.filter});
				this.loadItems(this.page);
			},
			updateProfile(row){
				console.log('Initiate update profile... ', row.item.mbsdFile);
				this.$store.dispatch('CHANGEPROFILE', {data:row.item.mbsdFile})
					.then(s=>{
						this.loadItems(this.page);
						// row.item.mbsdStatus = 1;
						// this.enabled = false;
						console.log(s);
					})
					.catch(e=>{
						console.log(e);
					})

			},
			approveBallot(d){
				console.log('Initiate ballot approval... ', d);
				var r = confirm("Do you want to manually approve ballot, this action is irreversible???");
				if (r == true) {
					this.$store.dispatch('APPROVEBALLOT', {data:d})
						.then(s=>{
							this.loadItems(this.page);
							// row.item.mbsdStatus = 1;
							// this.enabled = false;
							console.log(s);
						})
						.catch(e=>{
							console.log(e);
						})

				} else {
					console.log('Phewwwww....');
				}
			},
			rejectFastRunner(d){
				console.log('Initiate FR Rejection... ', d);
				var r = confirm("Are you sure this one is realllyy unqualified???, this action is irreversible!!!");
				if (r == true) {
					this.$store.dispatch('REJECTFRQ', {data:d})
						.then(s=>{
							this.loadItems(this.page);
							// row.item.mbsdStatus = 1;
							// this.enabled = false;
							console.log(s);
						})
						.catch(e=>{
							console.log(e);
						})

				} else {
					console.log('Phewwwww....');
				}
			},
		},
		mounted(){
			this.$store.commit('ACTIVATE_ADMIN');
			this.$store.dispatch('CHECK')
				this.loadItems(this.page)
			// this.$store.dispatch('CHECK')
				// .then((checkOut) =>{
				// 	console.log(checkOut);
				// 	this.data = checkOut.data;
				// 	// this.$store.commit('ACTIVATE_ADMIN');
				// 	this.$store.dispatch('GETMEMBERS',{})
				// 		.then(members=>{
				// 			this.items = members.data.data;
				// 			this.resource = members.data;
				// 			console.log('ABC : ', members.data.data);
				// 		});
				// })
				// .catch(err => {
				// 	console.log(err);
				// })
		},
	}
</script>


// WEBPACK FOOTER //
// FastRunnerTableView.vue